import { forwardRef } from 'react';
import MaterialBadge, { BadgeProps } from '@mui/material/Badge';

export const Badge = forwardRef<HTMLDivElement, BadgeProps>((props, ref) => {
    return (
        <MaterialBadge ref={ref} data-testid={'Badge-container'} {...props} />
    );
});

export default Badge;
